import { useEffect, useRef, useState } from "react";
import "./Book.css";

import { IonButton, IonGrid, IonLoading, IonRow } from "@ionic/react";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import { getTechno, getType, mapBook } from "./BookUtils";
import PDFViewer from "./Viewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface Props {}

const Book: React.FC<Props> = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const bookType = useRef(urlParams.get("type") ?? "");
  const techno = useRef(getCurrentTechnoOrDisconnect());

  const bookID = useRef(techno.current + "-" + bookType.current);
  const bookLink = mapBook.get(bookID.current) ?? "";

  const [bookLoader, setBookLoader] = useState<boolean>(true);
  const ref = useRef<HTMLDivElement>(null);

  return (
    <BasicPage
      width="10"
      pathReturn
      title={
        "Vous visionnez le livre de " +
        getType(bookType.current) +
        " pour " +
        getTechno(techno.current)
      }
    >
      {bookLink.length > 0 ? (
        <div>
          {bookLink.length > 1 && (
            <div
              style={{ overflow: "auto", maxHeight: "90vh", marginBottom: 50 }}
              className="border-primary-contrast border-radius"
            >
              <div
                style={{ overflow: "auto", maxHeight: "100vh" }}
                className="border-primary-contrast border-radius"
              >
                <IonLoading isOpen={bookLoader} message={"Chargement..."} />
                <div ref={ref} style={{ height: 900 }}>
                  <PDFViewer
                    isItBook={true}
                    fileURL={bookLink}
                    setBookLoader={(isLoad) => setBookLoader(isLoad)}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <IonGrid>
          <IonRow class="ion-justify-content-center">
            <IonButton shape="round" color="secondary" disabled strong>
              Disponible Prochainement
            </IonButton>
          </IonRow>
        </IonGrid>
      )}
    </BasicPage>
  );
};

export default Book;
